module.exports = __webpack_public_path__ + "img/trash_icon_on_image.4f259306.svg";